import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
//components
import SnackBar from '../../../SnackBar';
import TableWidget from '../../TableWidget';
//modals
import AllReports from '../../TableWidget/components/Modals/AllReports';
import VideoModal from '../../TableWidget/components/Modals/VideoModal';
import ConfirmationDialog from '../../../ConfirmationDialog';
//slices
import { closeModal } from '../../../../store/slices/searchSlice';
//constants
import { MODAL_TYPES } from '../../../../constants'
import { para_be } from '../../../../config';


const ScansDoneTable = () => {
    const dispatch = useDispatch();
    const { selectedRowInTable, modals } = useSelector(state => state.table);
    const [notifState, setNotifState] = useState(null);
    
    const handleCloseModal = (modalName) => {
        if (modals.uploaderModal) return;
        dispatch(closeModal(modalName));
    };

    const handleReprocessInspection = () => {
        const sid = selectedRowInTable.sid;
        dispatch(closeModal(MODAL_TYPES.REPROCESS_INSPECTION_MODAL));
        setNotifState({ type: 'info', text: 'Reprocessing inspection...' });

        axios.post(para_be + "/scan/reProcessInspection", { sid }, { withCredentials: true })
        .then(response => {
            if (response.status === 200 && response.data.status === 200) {
                setNotifState({ type: 'success', text: 'Inspection reprocessed successfully.' });
            } else {
                setNotifState({ type: 'error', text: response.data.msg || 'Failed to reprocess inspection.' });
            }
        })
        .catch(error => {
            console.error('Error reprocessing inspection:', error);
            setNotifState({ type: 'error', text: 'Failed to reprocess inspection.' });
        });
    }
    
    
    return (
        <>
            {/* Modals */}
            {modals.videoModal && (
                <VideoModal
                    open={modals.videoModal}
                    handleClose={() => handleCloseModal(MODAL_TYPES.VIDEO_MODAL)}
                    pid={selectedRowInTable.pid}
                    subject={selectedRowInTable.subject}
                />
            )}
            {modals.allReportsModal && (
                <AllReports
                    open={modals.allReportsModal}
                    handleClose={() => handleCloseModal(MODAL_TYPES.ALL_REPORTS_MODAL)}
                    pid={selectedRowInTable.pid}
                    subject={selectedRowInTable.subject}
                />
            )}
            {modals.reProcessInspection && (
                <ConfirmationDialog
                    open={modals.reProcessInspection}
                    handleClose={() => handleCloseModal(MODAL_TYPES.REPROCESS_INSPECTION_MODAL)}
                    handleRemove={handleReprocessInspection}
                    primaryBtnText={'Reprocess Inspection'}
                    text={`It might take a few minutes to complete.`}
                    header={'Please confirm that you want to reprocess this inspection.'}
                />
            )}
            {/* Main Table Layout */}
            <TableWidget showExpandedRows={true} />
            {/* Snackbar Notification */}
            {Boolean(notifState) && (
                <SnackBar
                    open={Boolean(notifState)}
                    handleClose={() => setNotifState(null)}
                    severity={(notifState.type === 'error' || notifState.type === 'info') ? notifState.type : 'success'}
                    message={notifState.text}
                    duration={6000}
                />
            )}
        </>
    );
};

export default ScansDoneTable;